import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const res = await axios.get(`${API_URL}/administrators`, { params: criteria });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, administratorId) {
      const res = await axios.get(`${API_URL}/administrators/${administratorId}`);

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async create(_, administratorData) {
      const res = await axios.post(`${API_URL}/administrators`, administratorData);

      if (res.status !== 201 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async update(_, { administratorId, administratorData }) {
      const res = await axios.put(
        `${API_URL}/administrators/${administratorId}`,
        administratorData,
      );

      if (res.status !== 200 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async remove(_, administratorId) {
      const res = await axios.delete(`${API_URL}/administrators/${administratorId}`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async activate(_, administratorId) {
      const res = await axios.post(`${API_URL}/administrators/${administratorId}/activate`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async deactivate(_, administratorId) {
      const res = await axios.post(`${API_URL}/administrators/${administratorId}/deactivate`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};

export default store;
